import { axiosInstance, downloadBlobDataFile } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostStocksSkuExcelDownloadParams } from '~/types/stock.types';

/**
 * 재고관리 - 상품별 조회 - 조회 결과 엑셀 다운로드 API
 */
const usePostStocksSkuExcelDownload = () => {
  const endpoint = '/api-inventory/v1/third-parties/stocks/sku/excel-download';

  const postStocksSkuExcelDownload = async (params: TypePostStocksSkuExcelDownloadParams) => {
    return axiosInstance
      .post<Blob>(endpoint, params, { responseType: 'blob' })
      .then(async (data) => {
        const responseString = await data.data.text();
        const isNoDataError = responseString.includes('데이터가 존재하지 않습니다.');

        if (isNoDataError) {
          const parsedResponse = JSON.parse(responseString);

          throw new Error(parsedResponse.error.message);
        }

        downloadBlobDataFile(data);
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postStocksSkuExcelDownload };
};

export default usePostStocksSkuExcelDownload;
